import { CHANGE_CITY } from './type';

const storageName = 'city';
const data = JSON.parse(localStorage.getItem(storageName)) ?? { city: {} };

const initState = {
    items: data.city,
};

export const cityReducer = (state = initState, action) => {
    switch (action.type) {
        case CHANGE_CITY: {
            localStorage.setItem(
                storageName,
                JSON.stringify({ city: action.payload })
            );
            return { ...state, items: action.payload };
        }
        default:
            return state;
    }
};
